import api from "@/utils/api";

export const getSourceStatusLeads = async (params : any) => {
  const response = await api.req({
    url: "/reports/source-status-leads",
    method: api.Method.POST,
    body: params
  });
  return response;
};

export const getFacebookLeads = async (params : any) => {
  const response = await api.req({
    url: "/reports/facebook-leads", 
    method: api.Method.POST,
    body: params
  });
  return response;
};

export const getGoogleLeads = async (params : any) => {
  const response = await api.req({
    url: "/reports/google-leads",
    method: api.Method.POST,
    body: params
  });
  return response;
};

export const getLeadsByStatus = async (params : any) => {
  const response = await api.req({
    url: "/reports/status-leads",
    method: api.Method.POST,
    body: params
  });
  return response;
};

export const getLeadsBySource = async (params : any) => {
  const response = await api.req({
    url: "/reports/source-leads",
    method: api.Method.POST,
    body: params
  });
  return response;
};